export const US_DATE_FORMAT = 'MM/dd/yyyy'
export const ILM_DATE_FORMAT = 'MM-dd-yyyy'
